import React, { useEffect, useMemo, useState } from "react";

import { makeStyles } from "@mui/styles";
import { ContentFullFromChatType } from "./ChatModelType";

type ChatPostContentProps = {
  onEvent: (e: any) => any;
  setProp?: any;
  history: any;
  channelId: any;
  contentPayload: any;
  author: any;
  sendAt: string;
  chatName?: string;
  messageId?: any;
  onLoadImage?: (id: any) => void;
};

const useStyles = makeStyles(() => ({
  textContainer: {
    cursor: "pointer",
    WebkitTapHighlightColor: "transparent",
    transition: "all 0.3s ease",
    "&:hover": {
      opacity: 0.8,
    },
  },
}));

const ChatPostContent = (props: ChatPostContentProps) => {
  console.log("Debug ~ ChatPostContent ~ props:", props);
  const classes = useStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  const previewsText = useMemo(() => {
    const text: string = props.contentPayload?.previews_text || "";

    if (text.length <= 100) {
      return text;
    }

    if (isExpanded) {
      return (
        <span
          className={classes.textContainer}
          // onClick={() => setIsExpanded(false)}
        >
          {text}
        </span>
      );
    }

    return (
      <span
        className={classes.textContainer}
        // onClick={() => setIsExpanded(true)}
      >
        {text.slice(0, 100)}
        <label style={{ color: "rgba(229, 67, 110, 1)" }}>...See more</label>
      </span>
    );
  }, [props.contentPayload, isExpanded]);

  const previewsPicture = useMemo((): string[] => {
    return props.contentPayload?.previews_picture ?? [];
  }, [props.contentPayload]);

  const previewsVideo = useMemo((): string[] => {
    return props.contentPayload?.previews_video ?? [];
  }, [props.contentPayload]);

  const handleSeeDetail = () => {
    console.error("Debug ~ handleSeeDetail ~ not supported on desktop" );
  };

  return (
    <div onClick={handleSeeDetail}>
      {previewsText}
      <div>
        {previewsPicture.map((img, index) => (
          <img
            key={`preview-image-${index}`}
            src={img}
            alt="preview-img.icon"
            style={{
              width: "100%",
              borderRadius: "5px",
              margin: "0.25rem 0",
              pointerEvents: "none",
            }}
            onLoad={() => props.onLoadImage?.(`${props.messageId}-${index}`)}
          />
        ))}
        {previewsVideo.map((vdo, index) => (
          <iframe
            key={`preview-vdo-${index}`}
            title={`Preview Video ${index + 1}`}
            src={vdo}
            style={{
              width: "100%",
              borderRadius: "5px",
              margin: "0.25rem 0",
              border: "none",
              pointerEvents: "none",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default ChatPostContent;
